import { useEffect, useState, useSyncExternalStore } from "react";
import { useIch } from "../api/abfragen";
import { rueckfallGefragt, rueckfallMerken } from "../api/freigabeRueckfall";
import { hinweisBeobachten, hinweisGezeigt, hinweisOffen } from "../api/nutzungHinweis";
import { useToastSichtbar } from "../design/toastKontext";
import { FreigabeSheet } from "./FreigabeSheet";

/** W81 B5 (Nachtrag D-433 Punkt 4, Auflage A3): hat das Konto `alle` gewaehlt, aber einer aelteren Fassung der Einwilligung
 *  zugestimmt, meldet `ich` die Marke und die Wahl steht schon auf `einzeln`. Dann oeffnet die Startseite einmal je Sitzung
 *  das Blatt „Alle Briefe zur Verbesserung freigeben“ mit der neuen Fassung; keine eigene Route, die App bleibt bedienbar.
 *  Beide Knoepfe sichern eine Wahl (der Server loescht die Marke); Schliessen ohne Wahl sendet nichts, die Marke bleibt und
 *  das Blatt kommt erst in der naechsten Sitzung wieder. Wie der Hinweis zur Nutzungsstatistik nicht ueber einer Meldung und
 *  nicht ueber dessen Blatt: erst, wenn es gezeigt und wieder zu ist. */
export function FreigabeRueckfall() {
  const { data: ich } = useIch();
  const faellig = Boolean(ich?.brief_freigabe && ich.brief_freigabe_neu_einwilligen);
  const nutzungOffen = useSyncExternalStore(hinweisBeobachten, hinweisOffen, () => false);
  const nutzungKommt = Boolean(ich?.nutzer.nutzung_hinweis_offen && !ich.nutzer.nutzung_aus) && !hinweisGezeigt();
  const toastSichtbar = useToastSichtbar();
  const [offen, setOffen] = useState(false);

  // erst nach dem ersten Bild der Seite; der Merker erst im Takt (beim Oeffnen), sonst verbraucht ihn das Probe-Aushaengen
  // von StrictMode (wie NutzungHinweis)
  useEffect(() => {
    if (!faellig || toastSichtbar || nutzungOffen || nutzungKommt || rueckfallGefragt()) return;
    const takt = setTimeout(() => {
      rueckfallMerken();
      setOffen(true);
    }, 0);
    return () => clearTimeout(takt);
  }, [faellig, toastSichtbar, nutzungOffen, nutzungKommt]);

  return <FreigabeSheet dokument={null} rueckfall offen={offen} onSchliessen={() => setOffen(false)} />;
}
